export const hotelMealType: any = {
  none: "なし",
  breakfast: "朝食付き",
};
